export default __webpack_public_path__ + "static/media/ban-mobile-image-11.8e932fa9.jpg";